import { Sparkles } from "@/lib/icons";
import { LevelHeader, ShieldCount, ResilienceCount, XpBar, AchievementGrid } from "@/components/progress/ProgressParts";

export function ProgressPanel({ data }) {
  if (!data) return null;
  const { level, points_total, catalog, achievements } = data;
  const nextText = level.next_min ? `${level.next_min - points_total} pts to ${data.levels[level.index]?.name}` : "Top level reached";

  return (
    <div className="warm-card p-6 space-y-5" data-testid="progress-panel">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <LevelHeader level={level} levels={data.levels || []} />
        <div className="text-right flex items-center gap-4">
          {typeof data.shields === "number" && <ShieldCount shields={data.shields} max={data.max_shields || 2} />}
          <ResilienceCount count={data.resilience_count} />
          <div>
            <div className="font-mono text-3xl font-bold text-amber-800" data-testid="points-total">{points_total}</div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-stone-500">points</div>
          </div>
        </div>
      </div>

      <XpBar level={level} nextText={nextText} />
      <AchievementGrid catalog={catalog} unlockedCount={achievements.length} />

      {data.recent_events.length > 0 && (
        <div className="flex items-center gap-2 text-xs text-stone-500 font-mono">
          <Sparkles className="w-3.5 h-3.5 text-emerald-600" />
          Latest: +{data.recent_events[0].points} for {data.recent_events[0].type.replace("_", " ")}
        </div>
      )}
    </div>
  );
}
